import { CompraStatus } from '../generated/backend-enums.js';
export { CompraStatus };
export const CompraStatusMap = {
    [CompraStatus.SEM_OPORTUNIDADE]: 'Sem Oportunidade',
    [CompraStatus.EM_NEGOCIACAO]: 'Em Negociação',
    [CompraStatus.NEGOCIADO]: 'Negociado',
};
